import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Link } from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

function AccountMenu({
  t,
  theme,
  isDrawerOpen,
  setIsDrawerOpen,
  isActiveRoute,
  accountOpen,
  handleOpenAccount,
  handleLogout,
  listItemButtonStyles,
  listItemIconStyles,
  ListItemTextStyles,
}) {
  return (
    <>
      <ListItem
        key="Account"
        className="list-item"
        endIcon={accountOpen ? <ExpandLess /> : <ExpandMore />}
        onClick={() => {
          if (!isDrawerOpen) setIsDrawerOpen(true);
          handleOpenAccount();
        }}
        selected={isActiveRoute("account")}
        sx={{
          backgroundColor: accountOpen ? "#f5f5f5" : "transparent",
          transition: "background-color 300ms ease-in-out",
          padding: theme.spacing(0, 1),
        }}
      >
        <ListItemButton sx={listItemButtonStyles}>
          <ListItemIcon sx={listItemIconStyles}>
            <PersonOutlineIcon />
          </ListItemIcon>
          <ListItemText
            sx={ListItemTextStyles}
            primary={t("sidebar.MyAccountButton")}
          />
          {accountOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>

      <Collapse in={accountOpen} timeout="auto" unmountOnExit>
        <ListItem
          key="AccountInfo"
          className="list-item sub-item"
          disablePadding
          sx={{
            ml: 5,
            backgroundColor: accountOpen
              ? "rgba(0, 0, 0, 0.05)"
              : "transparent",
            borderLeft: accountOpen
              ? "1px solid #2879A8"
              : "1px solid transparent",
            transition:
              "background-color 0.3s ease, border-left-color 0.3s ease",
            "&:hover": {
              backgroundColor: "#BAD7E9",
              borderLeftColor: "#BAD7E9",
            },
          }}
        >
          <Link
            to={`${process.env.REACT_APP_KC_SERVER_URL}realms/${process.env.REACT_APP_KC_REALM_ID}/account/?referrer=${process.env.REACT_APP_KC_CLIENT_ID}#/personal-info`}
            target="_blank"
          >
            <ListItemButton sx={listItemButtonStyles}>
              <ListItemText primary={t("sidebar.MyAccountInfo")} />
            </ListItemButton>
          </Link>
        </ListItem>
        <ListItem
          key="AccountLogout"
          className="list-item sub-item"
          onClick={handleLogout}
          disablePadding
          sx={{
            ml: 5,
            backgroundColor: accountOpen
              ? "rgba(0, 0, 0, 0.05)"
              : "transparent",
            borderLeft: accountOpen
              ? "1px solid #2879A8"
              : "1px solid transparent",
            transition:
              "background-color 0.3s ease, border-left-color 0.3s ease",
            "&:hover": {
              backgroundColor: "#BAD7E9",
              borderLeftColor: "#BAD7E9",
            },
          }}
        >
          <ListItemButton sx={listItemButtonStyles}>
            <ListItemText primary={t("sidebar.MyAccountLogout")} />
          </ListItemButton>
        </ListItem>
      </Collapse>
    </>
  );
}

export default AccountMenu;
